import { useTheme } from "@emotion/react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import { useRef } from "react";
import { HEADER, NAV } from "src/layouts/dashboard/config-layout";
import GoogleResponsiveAd from "../advert/GoogleReponive";

export default function AdCard({
  adImage,
  adTitle,
  adBody,
  adCtaText,
  maxHeight,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        height:
          maxHeight ||
          (isMobile
            ? `calc(99dvh - ${NAV.MOBILE}px)`
            : `calc(100vh - ${HEADER.H_DESKTOP + 150}px )`),
        margin: "auto 0",
        mb: 2,
        scrollSnapAlign: isMobile ? "start" : "center",
        ...(isMobile && { borderRadius: 0 }),
      }}
    >
      <GoogleResponsiveAd />
    </Card>
  );
}
